import React, { Component, Fragment } from "react";
import queryString from "query-string";
import { Link } from "react-router-dom";
import swal from "sweetalert";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as RegionsActions } from "store/ducks/regions";

import { Access } from "common";
import {
  Page,
  Panel,
  Loading,
  Pagination,
  Breadcrumbs,
  Icon
} from "components";

class List extends Component {
  state = {
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Regiões", to: "/" }
    ]
  };

  componentDidMount() {
    const { location, getRegionsRequest } = this.props;
    const params = queryString.parse(location.search);
    const page = params.page ? params.page : 1;

    getRegionsRequest(page);
  }

  componentDidUpdate(oldProps) {
    const { location, getRegionsRequest } = this.props;

    if (
      queryString.parse(oldProps.location.search).page !==
      queryString.parse(location.search).page
    ) {
      getRegionsRequest(queryString.parse(location.search).page);
    }

    if (
      queryString.parse(oldProps.location.search).removed !==
      queryString.parse(location.search).removed
    ) {
      getRegionsRequest(queryString.parse(location.search).page);
    }
  }

  handleDelete = async id => {
    const remove = await swal({
      title: "Remover a região",
      text: "Deseja mesmo remover a região?",
      buttons: {
        cancel: "Cancelar",

        confirm: {
          text: "Sim, remover"
        }
      }
    });

    remove && this.props.deleteRegionRequest(id);
  };

  render() {
    const { breadcrumbs } = this.state;
    const { regions } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Page.Title>Lista de Regiões</Page.Title>

        <Panel className="panel-list">
          {!regions.data.length && regions.loading ? (
            <Loading type="page" size="x-large" />
          ) : (
            <Fragment>
              {regions.loading && <Loading type="table" size="x-large" />}

              <table className="contact-table table table-curved table-striped">
                <thead>
                  <tr>
                    <th>região</th>
                    <th className="text-right">ações</th>
                  </tr>
                </thead>
                <tbody>
                  {!regions.data.length && (
                    <tr>
                      <td colSpan="6" className="text-center">
                        Nenhum registro encontrado.
                      </td>
                    </tr>
                  )}

                  {regions.data.map((region, index) => (
                    <tr key={region.id}>
                      <td>{region.attributes.name}</td>
                      {Access.hasPermissions("edit-regions") && (
                        <td className="text-right">
                          <Link
                            to={`/regions/${region.id}/edit`}
                            className="button-icon"
                          >
                            <Icon name="pencil" />
                          </Link>

                          <button
                            type="button"
                            className="button-icon"
                            onClick={() => this.handleDelete(region.id)}
                          >
                            <Icon name="trash-can" />
                          </button>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>

                <tfoot>
                  <tr>
                    <th colSpan="6" />
                  </tr>
                </tfoot>
              </table>

              <Pagination
                current={regions.page}
                total={regions.totals}
                {...this.props}
              />

              {Access.hasPermissions("edit-regions") && (
                <Link className="button-add" to="/regions/create">
                  Adicionar Região
                </Link>
              )}
            </Fragment>
          )}
        </Panel>
      </Page>
    );
  }
}

const mapState = state => ({
  regions: state.regions
});

const mapActions = dispatch => bindActionCreators(RegionsActions, dispatch);

export default connect(mapState, mapActions)(List);
